import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "assistant-screen-wrapper" }

import ChatComponent from '@/components/common/chat/ChatComponent.vue';
import ChatHeader from '@/components/common/chat-header/ChatHeader.vue';
import { AssistantType } from '@/models/assistant-types';
import { useLegalAssistant } from '@/composables/useLegalAssistant';
import { computed, ref, ComputedRef } from 'vue';
import { useStreaming } from '@/composables/useStreaming';
import { useUserSettingsStore } from '@/stores/userSettingsStore';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';
import { RagIndex } from '@/core/indexesEnum';


export default /*@__PURE__*/_defineComponent({
  __name: 'LegalAssistantView',
  setup(__props) {

const { legalAssistantRef, legalAssistantProps } = useLegalAssistant();

const userSettingsStore = useUserSettingsStore();

const selectedRagIndex: ComputedRef<RagIndex | string | undefined> = computed(
  () => userSettingsStore.getSafeSelectedRagIndex()
);

const useStreamingResponse = useStreaming(selectedRagIndex);

const route = useRoute();
const authStore = useAuthStore();

const selectedConversationId = ref<string | undefined>(
  route.query.conversationId as string | undefined
);
const showHistory = ref(!authStore.IsConcurrentUser);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ChatHeader, {
      assistant: _unref(AssistantType).LegalAssistant,
      "reset-conversation": 
        !!_unref(legalAssistantRef) ? _unref(legalAssistantRef).resetConversation : () => {}
      ,
      "enable-new-conversation-button": true,
      "current-conversation-id": selectedConversationId.value,
      "show-history": showHistory.value
    }, null, 8, ["assistant", "reset-conversation", "current-conversation-id", "show-history"]),
    _createVNode(ChatComponent, _mergeProps({
      ref_key: "legalAssistantRef",
      ref: legalAssistantRef
    }, _unref(legalAssistantProps), {
      "selected-conversation-id": selectedConversationId.value,
      "use-streaming-response": _unref(useStreamingResponse)
    }), null, 16, ["selected-conversation-id", "use-streaming-response"])
  ]))
}
}

})